import React from 'react';
import { Box, Typography, TextField } from '@mui/material';
import DashboardLayoutSlots from './DashboardLayoutSlots'; // Import the layout
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';


// Profile component
function RM() {
  return (
    // Make sure DashboardLayoutSlots wraps the Profile page content
    <DashboardLayoutSlots>
      <Box sx={{ padding: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Repair & Maintenance Request
        </Typography>

        {/* Requestor Information Accordion */}
        <Accordion >
          <AccordionSummary
            expandIcon={<ArrowDownwardIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography component="span">Requestor Information</Typography>
          </AccordionSummary>

          <AccordionDetails>
            {/* Stack the TextFields vertically and take full width */}
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
              <TextField required id="outlined-required" label="Name" defaultValue="Izzat Rahman" fullWidth />
              <TextField id="outlined-required"  label="Contact No" defaultValue="0132227368" fullWidth />
              <TextField id="outlined-required" label="Email" defaultValue="izzat@evantage.com" fullWidth />
            </Box>
          </AccordionDetails>
        </Accordion>

        {/* Job Request Information Information Accordion */}
        <Accordion defaultExpanded>
          <AccordionSummary expandIcon={<ArrowDownwardIcon />} aria-controls="panel1-content" id="panel1-header" >
            <Typography component="span">Job Request Information</Typography>
          </AccordionSummary>

          <AccordionDetails>
            {/* Stack the TextFields vertically and take full width */}
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
              <TextField required id="outlined-required" label="Date" defaultValue="01/01/2024" slotProps={{input: {readOnly: true,},}} fullWidth />
              
              <FormControl fullWidth>
                <InputLabel id="wko_area">Work Area</InputLabel>
                <Select labelId="Work Area" id="wko_area" label="Work Area" >
                  <MenuItem value={10}>MDSB</MenuItem>
                </Select>
              </FormControl>

              <FormControl fullWidth>
                <InputLabel id="wko_locn">Asset Location</InputLabel>
                <Select labelId="Asset Location" id="wko_locn" label="Asset Location" >
                  <MenuItem value={1}>BOILER</MenuItem>
                  <MenuItem value={2}>C1 PLANT</MenuItem>
                </Select>
              </FormControl>

              <FormControl fullWidth>
                <InputLabel id="ast_cd">Asset Code</InputLabel>
                <Select labelId="Asset Code" id="ast_cd" label="Asset Code" >
                  <MenuItem value={1}>AIR COND</MenuItem>
                  <MenuItem value={2}>CONVEYOR</MenuItem>
                </Select>
              </FormControl>

              <FormControl fullWidth>
                <InputLabel id="ast_no">Asset No</InputLabel>
                <Select labelId="Asset No" id="ast_no" label="Asset No" >
                  <MenuItem value={1}>ACC043-01</MenuItem>
                  <MenuItem value={2}>ACC043-02</MenuItem>
                </Select>
              </FormControl>

              <FormControl fullWidth>
                <InputLabel id="Priority">Priority</InputLabel>
                <Select labelId="Priority" id="Priority" label="Priority" >
                  <MenuItem value={1}>LOW</MenuItem>
                  <MenuItem value={2}>MEDIUM</MenuItem>
                  <MenuItem value={3}>HIGH</MenuItem>
                </Select>
              </FormControl>
              

              <TextField id="outlined-required" label="Work Group" fullWidth />
              <TextField id="outlined-required" label="Fault Code" fullWidth />
              <TextField id="outlined-required" label="Job Request Description" multiline fullWidth />
            </Box>
          </AccordionDetails>
        </Accordion>
      </Box>
    </DashboardLayoutSlots>
  );
}

export default RM;
